<script>
import { h, Teleport, resolveComponent } from "vue";
import { mapActions } from "pinia";
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import DynamicComponentActionElement from "%/dynamic-component-editor/standard-elements/action-element/DynamicComponentActionElement.vue";
import { ELEMENT_PANEL_FOLDER } from "%/dynamic-component-editor/constants/element-panel-folder-names";
import { useStoryStore } from "%/dynamic-component-editor/stores/story-store";
import { applyStoryFields }
  from "%/dynamic-component-editor/standard-components/base-story-card/member-post-feed-actions";
import { REPORT_REASONS } from "%/helpers/report-reasons.mjs";

export default {
  name: "ReportAction",
  elementPanelSettings: {
    folder: ELEMENT_PANEL_FOLDER.ACTIONS,
    displayIcon: "exclamation-triangle",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: DynamicComponentActionElement,
  mixins: [BaseStoryCardElementMixin],
  data() {
    return {
      isPickingReason: false,
      isSavingReport: false,
      reportedStoryIds: [],
      reasons: REPORT_REASONS,
    };
  },
  computed: {
    isLoading() {
      return this.isSavingReport;
    },
    alreadyReported() {
      return this.reportedStoryIds.includes(this.storyEntityId);
    },
    myValue() {
      return this.myDisplayValue === "show" ? this.entity?.numReports ?? 0 : "";
    },
    reportPublicationId() {
      return Number(this.entity?.publication?.pk?.id ?? 0);
    },
    shouldShowAction() {
      return true;
    },
  },
  methods: {
    ...mapActions(useStoryStore, ["reportMemberPost"]),
    handleClick() {
      // The canvas renders an example entity; reporting there would file a
      // report against a story the author is only previewing.
      if (this.editMode || this.isPreviewMode || this.alreadyReported) {
        return;
      }
      if (!this.storyEntityId || !this.reportPublicationId) {
        return;
      }
      this.isPickingReason = true;
    },
    closeReasonPicker() {
      this.isPickingReason = false;
    },
    sendReport(reason) {
      const storyId = this.storyEntityId;
      this.isPickingReason = false;
      this.isSavingReport = true;
      this.reportMemberPost(
        this.reportPublicationId,
        storyId,
        reason,
        fields => {
          this.isSavingReport = false;
          this.reportedStoryIds = [...this.reportedStoryIds, storyId];
          applyStoryFields(storyId, fields);
        },
        () => {
          this.isSavingReport = false;
        },
      );
    },
    reasonPickerVNode() {
      const iModal = resolveComponent("iModal");
      const iColumn = resolveComponent("iColumn");
      const iText = resolveComponent("iText");
      const iButton = resolveComponent("iButton");

      return h(Teleport, { to: "body" }, [
        h(iModal, {
          maxWidth: 420,
          showFooter: false,
          visible: true,
          title: "Report this post",
          onClose: this.closeReasonPicker,
        }, {
          body: () => h(iColumn, { gap: "small", width: "fill", wrap: "nowrap" }, () => [
            h(iText, { variant: "subtle" }, () => "Tell the moderators what is wrong with it. "
              + "They see every report on a post together."),
            ...this.reasons.map(reason => h(iButton, {
              key: reason.value,
              variant: "secondary",
              width: "fill",
              textAlignment: "left",
              onClick: () => this.sendReport(reason.value),
            }, () => reason.label)),
          ]),
        }),
      ]);
    },
  },
  // The action button itself is the BASE element's template, untouched — that
  // template is where the branding lives (style-overrides, icon colour, border
  // sides, the prefix/suffix wrapper and the count column). Hand-rolling a
  // second iButton here is what made Report look unlike every other action.
  // The reason picker is appended as a sibling instead.
  render(...args) {
    const actionButton = DynamicComponentActionElement.render.call(this, ...args);
    if (!this.isPickingReason) {
      return actionButton;
    }
    return [actionButton, this.reasonPickerVNode()];
  },
};
</script>
